module.exports = __webpack_public_path__ + "img/男-食管癌h.208a3ed9.png";